import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromInfo from './info.reducer';
import { EffectsModule } from '@ngrx/effects';
import { InfoEffects } from './info.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromInfo.infoFeatureKey, fromInfo.reducer),
    EffectsModule.forFeature([InfoEffects]),
  ],
})
export class InfoStoreModule {}
